import React from 'react'
import { useIsMobile } from 'hooks/device-detect'
import ReactTooltip from 'react-tooltip'
import { Icon } from 'layouts'
import { ImageTooltipType } from '../../types'
import s from './NewsImageEmbed.module.scss'

interface Props {
    content: ImageTooltipType
}

const NewsImageEmbed = ({ content }: Props): JSX.Element | null => {
    const isMobile = useIsMobile()

    return (
        <span className={s.imageTooltip}>
            <span
                data-for={content.sys.id}
                data-tip={content?.title}
                className={s.tooltipText}
            >
                {content?.title}
                <Icon className={s.imageIcon} regular name="image" />
            </span>

            {/* ───────── tooltip ───────── */}
            <ReactTooltip
                id={content.sys.id}
                wrapper="span"
                effect="solid"
                type="dark"
                clickable /* ① allow mouse into balloon */
                delayHide={isMobile ? 0 : 150}
                delayUpdate={isMobile ? 0 : 150}
                aria-haspopup="true"
                border={false}
                backgroundColor="#29353a"
                className={s.tooltip}
                globalEventOff="click"
                place="top"
            >
                <img
                    src={`${content.image?.url}?w=700`}
                    alt={content.image?.description ?? ''}
                />
            </ReactTooltip>
        </span>
    )
}

export default NewsImageEmbed
